(function () {
  'use strict';

  function readGa4Dataset(el) {
    if (!el) return null;

    return {
      item_id: el.getAttribute('data-ga4-item-id') || '',
      item_name: el.getAttribute('data-ga4-item-name') || '',
      index: Number(el.getAttribute('data-ga4-index') || 1),
      item_list_id: el.getAttribute('data-ga4-item-list-id') || 'Info_banner',
      item_list_name: el.getAttribute('data-ga4-item-list-name') || 'Info_banner',
      item_category: el.getAttribute('data-ga4-item-category') || '',
      item_category2: el.getAttribute('data-ga4-item-category2') || 'Standard',
      item_category3: (el.getAttribute('data-ga4-item-category3') || '').replace('Default Title', 'none'),
      item_variant: el.getAttribute('data-ga4-item-variant') || 'Truewireless',
      price: Number(el.getAttribute('data-ga4-price') || 0) / 100,
      quantity: Number(el.getAttribute('data-ga4-quantity') || 1),
      currency: el.getAttribute('data-ga4-currency') || 'AUD',
      discountCents: Number(el.getAttribute('data-ga4-discount') || 0)
    };
  }

  function buildGa4Item(config) {
    var item = {
      item_id: config.item_id,
      item_name: config.item_name,
      index: config.index,
      item_list_id: config.item_list_id,
      item_list_name: 'Navigation _ ' + config.item_list_name,
      item_category: config.item_category,
      item_category2: config.item_category2,
      item_category3: config.item_category3,
      item_variant: config.item_variant,
      item_brand: 'SHOKZ',
      price: config.price,
      quantity: config.quantity,
      currency: config.currency
    };

    if (config.discountCents > 0) {
      item.discount = config.discountCents / 100;
    }

    return item;
  }

  function pushInfoBannerSelectItem(config, buttonName) {
    if (!config || !config.item_id) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push({
      event: 'ga4Event',
      event_name: 'select_item',
      event_parameters: {
        item_list_id: config.item_list_id,
        item_list_name: config.item_list_name,
        button_name: buttonName,
        items: [buildGa4Item(config)]
      }
    });
  }

  function bindInfoBannerGa4(scope) {
    var root = scope || document;
    root.querySelectorAll('.opendots-info-banner__ga4-data').forEach(function (dataEl) {
      if (dataEl.dataset.ga4Bound === 'true') return;
      dataEl.dataset.ga4Bound = 'true';

      var sectionRoot = dataEl.closest('[id^="shopify-section-"]');
      if (!sectionRoot) return;

      var buyBtn = sectionRoot.querySelector('.banner-buy-now');
      if (!buyBtn || buyBtn.dataset.ga4Bound === 'true') return;
      buyBtn.dataset.ga4Bound = 'true';

      buyBtn.addEventListener('click', function () {
        var config = readGa4Dataset(dataEl);
        if (!config) return;
        var buttonName = (buyBtn.textContent || '').trim();
        if (!buttonName) return;
        pushInfoBannerSelectItem(config, buttonName);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    bindInfoBannerGa4(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    bindInfoBannerGa4(event.target);
  });
})();
